export default {
    pedidosAvulso: [],
    pedidoAvulso: {},
    ultimaAtualizacaoListaPedidoAvulso: Date
}